<template>
    <ul class="uk-list">
        <template v-for="filter in appliedFilters">
            <template v-if="canCycle(filter.value)">
                <li v-for="(label, value) in filter.value">
                    <a @click="removeFilter(filter.slug, value)">
                        <span class="uk-badge">
                            {{ filter.label }}: {{ label }}
                            <i class="fal fa-times uk-margin-small-left"></i>
                        </span>
                    </a>
                </li>
            </template>
            <li v-else>
                <a @click="removeFilter(filter.slug, filter.value)">
                    <span class="uk-badge">
                        {{ filter.label }}: {{ filter.value }}
                        <i class="fal fa-times uk-margin-small-left"></i>
                    </span>
                </a>
            </li>
        </template>
    </ul>
</template>

<script>
  export default {
    computed: {
      appliedFilters() {
        return this.$store.state.grid.meta.applied_filters;
      },
    },
    methods: {
      canCycle(value) {
        return Array.isArray(value) || typeof value == 'object';
      },
      removeFilter(slug, value) {
        this.$store.commit('grid/removeFilter', {column: slug, value: value});
      },
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/cinquanta3/extensions/rubinred/catalog/assets/js/components/CatalogAppliedFilters.vue